import { useMutation, useQueryClient } from 'react-query';

import { projectsApi } from 'src/Services/API';
import { VoteProjectDtoVoteEnum } from 'src/Services/API/generated/api';
import { trackEvent } from 'src/Services/Matomo';

const useVoteProject = (assetId: string) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ projectId, vote }: { projectId: string; vote: VoteProjectDtoVoteEnum }) =>
      projectsApi.projectsControllerVote(projectId, assetId, { vote }),
    onSuccess: (_response, { vote }) => {
      trackEvent('Project', 'vote', vote);
      queryClient.invalidateQueries({ queryKey: ['projects', assetId] });
    },
  });
};

export default useVoteProject;
